import { AdminAppEvent, isEventInstance, LegacyAdminAppEvent } from './AppEvent';
export const LAB_ADMIN_OPEN_EVENT_NAME = 'open-lab-admin';
export const LAB_ADMIN_CLOSE_EVENT_NAME = 'close-lab-admin';
export class OpenLabAdminEvent extends AdminAppEvent {
    constructor() {
        super({ eventName: LAB_ADMIN_OPEN_EVENT_NAME });
    }
    static isInstanceOf = (object) => {
        return AdminAppEvent.isInstanceOf(object) && isEventInstance(object, LAB_ADMIN_OPEN_EVENT_NAME);
    };
}
export class CloseLabAdminEvent extends LegacyAdminAppEvent {
    constructor() {
        super({ eventName: LAB_ADMIN_CLOSE_EVENT_NAME });
    }
    static isInstanceOf = (object) => {
        return LegacyAdminAppEvent.isInstanceOf(object) && isEventInstance(object, LAB_ADMIN_CLOSE_EVENT_NAME);
    };
}
